module.exports = __webpack_public_path__ + "img/pen.a01f46d4.svg";